import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { menuLayoutRoute } from 'root/MenuLayout';

import { venuesSearchParamsSchema } from './schemas';

export const venuesRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: '/venues',
  component: lazyRouteComponent(() => import('./VenuesView')),
  validateSearch: venuesSearchParamsSchema,
});
